import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Shield, Lock, Vote, Link2, Scale, Users, ArrowLeft } from "lucide-react";
import { LanguageSelector } from "../components/LanguageSelector";

const sections = [
  { key: "DataProtection", icon: Shield },
  { key: "Encryption", icon: Lock },
  { key: "VoteSecret", icon: Vote },
  { key: "Blockchain", icon: Link2 },
  { key: "Rights", icon: Users },
  { key: "Compliance", icon: Scale },
];

export default function LegalPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900" data-testid="legal-back-link">
            <ArrowLeft className="h-4 w-4" />
            {t("common.back")}
          </Link>
          <LanguageSelector />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-900 rounded-2xl mb-6">
            <Shield className="h-8 w-8 text-amber-500" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-heading font-bold text-slate-900 mb-3" data-testid="legal-title">
            {t("legal.pageTitle")}
          </h1>
          <p className="text-slate-500 text-lg">{t("legal.pageSubtitle")}</p>
        </div>

        <div className="space-y-8">
          {sections.map(({ key, icon: Icon }) => (
            <section key={key} className="bg-white rounded-xl border border-slate-200 p-6 sm:p-8" data-testid={`legal-section-${key}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center">
                  <Icon className="h-5 w-5 text-slate-700" />
                </div>
                <h2 className="text-xl font-heading font-semibold text-slate-900">
                  {t(`legal.section${key}`)}
                </h2>
              </div>
              <p className="text-slate-600 leading-relaxed">
                {t(`legal.${key.charAt(0).toLowerCase() + key.slice(1)}Text`)}
              </p>
            </section>
          ))}
        </div>

        <div className="mt-12 text-center text-xs text-slate-400">
          <p>RGPD (UE 2016/679) &middot; LOPDGDD (LO 3/2018) &middot; LOREG (LO 5/1985)</p>
        </div>
      </main>
    </div>
  );
}
